var ensureStaleTime = function ensureStaleTime(defaultedOptions) {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};

var willFetch = function willFetch(result, isRestoring) {
  return result.isLoading && result.isFetching && !isRestoring;
};

var shouldSuspend = function shouldSuspend(defaultedOptions, result, isRestoring) {
  return (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
};

var fetchOptimistic = function fetchOptimistic(defaultedOptions, observer, errorResetBoundary) {
  return observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
    var data = _ref.data;
    defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
    defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
  }).catch(function (error) {
    errorResetBoundary.clearReset();
    defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
    defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
  });
};

export { ensureStaleTime, fetchOptimistic, shouldSuspend, willFetch };